import { select, all, call, put, race, take, takeEvery, takeLatest } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { delay } from 'redux-saga/effects'

import agent, { mocked } from 'agent'
import appMode from 'helpers/getAppMode'

import * as actions from 'redux/actions/serpChecker.actions'
import * as searchActions from '../actions/search.actions'
import * as appUsageActions from '../actions/appUsage.actions'

function* getSerpCheckerResultsSaga() {
  const state = yield select()
  const { value, location, device } = state.search
  if (!value) {
    yield put(searchActions.setError('Please enter a keyword'))
    return null
  }
  // We only allow 5 checks otherwise fail
  let strikes = 5
  let data = null
  while (strikes > 0) {
    try {
      let endpoint = agent.SerpChecker.get
      if (appMode.preview) {
        endpoint = mocked.SerpChecker.get
      }

      const payload = {
        serpChecker: {
          keyword: value,
          location,
          device
        }
      }
      const body = yield call(endpoint, payload)

      // stteeerike!
      strikes -= 1

      data = body.data
      const { attributes } = data
      const { status } = attributes

      if (status === 'complete') {
        yield put(actions.getSerpCheckerResultsSuccess(data))
      } else {
        yield put(actions.getSerpCheckerResultsNotReady(data))
      }

      yield delay(5000)
    } catch (error) {
      yield put(actions.getSerpCheckerResultsFailure(error))
    }
  }

  yield put(actions.getSerpCheckerResultsNotReady(data))
  yield put(actions.getSerpCheckerResultsFailure(null))
}

function* exportSerpCheckerResultsSaga(params) {
  try {
    const { payload } = params.payload
    const body = yield call(agent.SerpChecker.export, payload)
    yield put(actions.exportSerpCheckerResultsSuccess(body.data))
  } catch (error) {
    yield put(actions.exportSerpCheckerResultsFailure(error))
  }
}

function* loadSerpCheckerPreviousSaga(params) {
  try {
    const { historyId } = params.payload
    yield put(push(`/serp-checker/history/${historyId}`))
    const body = yield call(agent.SerpChecker.getPrevious, historyId)
    yield put(actions.loadSerpCheckerPreviousSuccess(body.data))
  } catch (error) {
    yield put(actions.loadSerpCheckerPreviousFailure(error))
  }
}

function* getSerpCheckerHistorySaga() {
  try {
    const body = yield call(agent.SerpChecker.getHistory)
    const data = body.data.map(item => ({
      attributes: {
        id: item.id,
        ...item.attributes
      }
    }))
    yield put(actions.getSerpCheckerHistorySuccess(data))
  } catch (error) {
    yield put(actions.getSerpCheckerHistoryFailure(error))
  }
}

function* pollSerpCheckerSaga() {
  const state = yield select()
  yield put(actions.setKeyword(state.search.value))
  yield race([
    call(getSerpCheckerResultsSaga),
    take(actions.getSerpCheckerResultsSuccess.type),
    take(actions.getSerpCheckerResultsFailure.type)
  ])
}

function* validateSerpCheckerSearch() {
  const state = yield select()
  const { used, limit } = state.appUsage.serpChecker
  const { value } = state.search

  if (limit && used && used >= limit) {
    yield put(searchActions.setError('Used monthly limit. Upgrade plan or try again later.'))
    return null
  }
  if (!value) {
    yield put(searchActions.setError('Please enter a keyword'))
    return null
  }

  yield put(appUsageActions.hitSerpChecker(1))
  yield put(actions.getSerpCheckerResults())
}

function* deleteKeywordsSaga(params) {
  const { historyId } = params.payload
  try {
    const data = yield call(agent.SerpChecker.del, historyId)
    yield put(actions.deleteKeywordsSuccess(data))
  } catch (error) {
    yield put(actions.deleteKeywordsFailure(error))
  }
}

export default function* keywordFinderSagas() {
  yield all([
    takeLatest(actions.getResults.type, validateSerpCheckerSearch),
    takeEvery(actions.getSerpCheckerResults.type, pollSerpCheckerSaga),
    takeLatest(actions.exportSerpCheckerResults.type, exportSerpCheckerResultsSaga),
    takeLatest(actions.loadSerpCheckerPrevious.type, loadSerpCheckerPreviousSaga),
    takeLatest(actions.getSerpCheckerHistory.type, getSerpCheckerHistorySaga),
    takeLatest(actions.deleteKeywords.type, deleteKeywordsSaga)
  ])
}
